import { createFileRoute, Navigate, Link, Outlet } from "@tanstack/react-router"
import { authClient } from "@/lib/auth-client"
import { isAdminUserId } from "@/lib/is-admin"

// Shared admin shell: a top nav whose items route to the admin sub-pages, with
// the active item highlighted via TanStack Router's `data-status="active"`.
const navLink = `px-3 py-1.5 rounded-full text-sm font-medium text-muted-foreground hover:bg-muted data-[status=active]:bg-primary data-[status=active]:text-primary-foreground`

function AdminLayout() {
  // The `_authenticated` parent already guarantees a session before rendering
  // here; we only need the admin role gate. Reads from the shared session store
  // (no extra fetch), so navigation isn't blocked.
  const { data: session, isPending } = authClient.useSession()

  if (isPending) {
    return null
  }
  if (!isAdminUserId(session?.user?.id)) {
    return <Navigate to="/dashboard" />
  }

  return (
    <div className="min-h-screen bg-background">
      <nav className="border-b border-border">
        <div className="max-w-6xl mx-auto px-4 sm:px-8 flex gap-2 py-3">
          <Link to="/admin" activeOptions={{ exact: true }} className={navLink}>
            Users
          </Link>
          <Link to="/admin/emails" className={navLink}>
            Emails
          </Link>
          <Link to="/admin/support" className={navLink}>
            Support
          </Link>
        </div>
      </nav>
      <Outlet />
    </div>
  )
}

export const Route = createFileRoute(`/_authenticated/admin`)({
  component: AdminLayout,
  ssr: false,
})
